<template>
  <div
    class="wf-field-preview"
    :class="{ 'wf-field-preview--interactive': interactive }"
  >
    <template v-if="field.type === 'textarea'">
      <textarea
        class="form-control wf-preview-input wf-preview-textarea"
        :placeholder="field.placeholder || ''"
        :value="value === null || value === undefined ? '' : value"
        :disabled="!interactive"
        rows="3"
        @input="$emit('input', $event.target.value)"
      ></textarea>
    </template>

    <template v-else-if="isTextLike">
      <input
        class="form-control wf-preview-input"
        :type="inputType"
        :placeholder="field.placeholder || ''"
        :value="value === null || value === undefined ? '' : value"
        :disabled="!interactive"
        @input="$emit('input', $event.target.value)"
      />
    </template>

    <template v-else-if="field.type === 'radio'">
      <div v-if="options.length" class="wf-choice-list">
        <label
          v-for="option in options"
          :key="option._uid"
          class="wf-choice-item"
        >
          <input
            type="radio"
            :name="'wf_preview_' + field._uid"
            :value="option.value"
            :checked="value === option.value"
            :disabled="!interactive"
            @change="$emit('input', option.value)"
          />
          <span>{{ optionLabel(option) }}</span>
        </label>
      </div>
      <div v-else class="wf-preview-empty">Belum ada pilihan.</div>
    </template>

    <template v-else-if="field.type === 'dropdown'">
      <select
        class="form-control wf-preview-input"
        :value="value === null || value === undefined ? '' : value"
        :disabled="!interactive"
        @change="$emit('input', $event.target.value)"
      >
        <option value="">Pilih...</option>
        <option
          v-for="option in options"
          :key="option._uid"
          :value="option.value"
        >
          {{ optionLabel(option) }}
        </option>
      </select>
      <div v-if="!options.length" class="wf-preview-empty mt-2">
        Belum ada pilihan.
      </div>
    </template>

    <template v-else-if="field.type === 'checkbox'">
      <div v-if="options.length" class="wf-choice-list">
        <label
          v-for="option in options"
          :key="option._uid"
          class="wf-choice-item"
        >
          <input
            type="checkbox"
            :value="option.value"
            :checked="isChecked(option.value)"
            :disabled="!interactive"
            @change="onCheckboxChange(option.value, $event.target.checked)"
          />
          <span>{{ optionLabel(option) }}</span>
        </label>
      </div>
      <div v-else class="wf-preview-empty">Belum ada pilihan.</div>
    </template>

    <template v-else>
      <input
        class="form-control wf-preview-input"
        type="text"
        :placeholder="field.placeholder || ''"
        :value="value === null || value === undefined ? '' : value"
        :disabled="!interactive"
        @input="$emit('input', $event.target.value)"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: "waajo-form-field-preview",
  props: {
    field: {
      type: Object,
      required: true
    },
    interactive: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Array, Boolean],
      default: ""
    }
  },
  computed: {
    options() {
      return Array.isArray(this.field.options) ? this.field.options : [];
    },
    isTextLike() {
      return (
        ["text", "whatsapp", "email", "number", "date"].indexOf(
          this.field.type
        ) !== -1
      );
    },
    inputType() {
      if (this.field.type === "email") {
        return "email";
      }
      if (this.field.type === "number") {
        return "number";
      }
      if (this.field.type === "date") {
        return "date";
      }
      if (this.field.type === "whatsapp") {
        return "tel";
      }
      return "text";
    }
  },
  methods: {
    optionLabel(option) {
      return option.label || option.value || "Opsi tanpa teks";
    },
    isChecked(value) {
      return Array.isArray(this.value) && this.value.indexOf(value) !== -1;
    },
    onCheckboxChange(value, checked) {
      const next = Array.isArray(this.value) ? this.value.slice() : [];
      const position = next.indexOf(value);
      if (checked && position === -1) {
        next.push(value);
      } else if (!checked && position !== -1) {
        next.splice(position, 1);
      }
      this.$emit("input", next);
    }
  }
};
</script>

<style scoped>
.wf-field-preview:not(.wf-field-preview--interactive) {
  pointer-events: none;
}

.wf-preview-input {
  height: 42px;
  border-color: #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.wf-preview-input:disabled {
  background: #ffffff;
  color: #64748b;
  cursor: default;
  opacity: 1;
}

.wf-preview-textarea {
  height: auto;
  min-height: 88px;
  resize: vertical;
}

.wf-choice-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wf-choice-item {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin: 0;
  color: #334155;
  font-size: 14px;
  font-weight: 400;
  cursor: inherit;
}

.wf-choice-item input[type="radio"],
.wf-choice-item input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  accent-color: #fe9b44;
}

.wf-preview-empty {
  padding: 10px 12px;
  border: 1px dashed #f3c79f;
  border-radius: 8px;
  background: #fffaf5;
  color: #b45309;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/forms/components/FieldPreview.vue